module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "ack",
      "epub:type": "acknowledgments",
      "role": "doc-acknowledgments"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FM-Head-fmh"
  }, [_c('span', {
    attrs: {
      "aria-label": "ix",
      "id": "pg_ix",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "id": "ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-No-Indent-fmtx1"
  }, [_vm._v("Of all those who have helped me during the writing of this book, I would particularly like to thank Julian Warren for his technical assistance. I would also like to thank Susan Watt for making editing such a painless process.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("I am especially indebted to Toby Eady for reasons too numerous to list here. Suffice to say that I regard this book as something of a joint venture.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c150588c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0